/**
 * Nested-IA alias route — round 4 / #228.
 *
 * Mounts the connection detail page at `/connections/api/$connectionId`
 * so the Codex full-baseline IA inventory resolves. The flat route at
 * `/connections/$connectionId` continues to work; both render the same
 * `ConnectionDetailPage` component, which auto-detects MCP vs API.
 *
 * The TanStack route param uses `$connectionId` (matching the existing
 * unified route's param name) rather than `$id` so the same shared
 * component can be reused without rewriting param plumbing. The URL
 * shape — `/connections/api/<uuid>` — matches the IA inventory; the
 * internal pattern token is implementation detail.
 */

import { createFileRoute } from '@tanstack/react-router';
import { ConnectionDetailPage } from './$connectionId';

export const Route = createFileRoute('/connections/api/$connectionId')({
  component: ApiConnectionDetailRoute,
});

function ApiConnectionDetailRoute() {
  const { connectionId } = Route.useParams();
  // #755 — typed alias knows this is the API side; skip the MCP lookup.
  return <ConnectionDetailPage connectionId={connectionId} expectedType="api" />;
}
